import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';
import * as Utils from '@shared/core/utils';

import { ModalViewComponent } from '../modal-view.shared.component';

@Component({
    selector: 'shared-modal-for-delivery-address',
    templateUrl: './modal-for-delivery-address.shared.component.html',
    styleUrls: ['./modal-for-delivery-address.shared.component.scss']
})
export class ModalForDeliveryAddressComponent extends ModalViewComponent implements OnInit {
    private _form!: FormGroup;
    private _address!: APICommon.IGooglePlaceDetails;

    private _submitForm!: (modalId?: number) => any;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'xsm';
    }

    public handleFormInit($event: FormGroup): void {
        this._form = $event;
    }

    public handleAddressSelected($event: APICommon.IGooglePlaceDetails): void {
        this._address = $event;
    }

    public handleCheckAddressClick($event: Event): void {
        console.log($event);
    }

    public get isFormValid(): boolean {
        return this._form?.valid === true && this._address !== null;
    }

}
